module.exports = __webpack_public_path__ + "3b4f5252a16e09379b452e83de86e8c3.png";